import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import SEOHeading from '../../components/ui/SEOHeading';

const NotFound = () => {
    return (
        <Container>
            <div className={styles.notFoundContainer}>
                <div className={styles.notFoundContent}>
                    <SEOHeading level={1}>404</SEOHeading>
                    <SEOHeading level={2}>Səhifə tapılmadı</SEOHeading>
                    <p>Axtardığınız səhifə mövcud deyil və ya silinib.</p>
                    <Link to="/">
                        <Button variant="primary">
                            Ana səhifəyə qayıt
                        </Button>
                    </Link>
                </div>
            </div>
        </Container>
    );
};

export default NotFound;